import { render, staticRenderFns } from "./AnalysisTable.vue?vue&type=template&id=79649990&scoped=true"
import script from "./AnalysisTable.vue?vue&type=script&lang=ts"
export * from "./AnalysisTable.vue?vue&type=script&lang=ts"
import style0 from "./AnalysisTable.vue?vue&type=style&index=0&id=79649990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79649990",
  null
  
)

export default component.exports